var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.sensitivityClass},[_c('Icon',{staticClass:"h-5 w-5",attrs:{"icon":_vm.sensitivityIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }